/*eslint-disable*/
export default (event) => {
   return event.target.value = event.target.value.replace(/[^\d,.-]+/gm, '');
}